import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { Component, Input, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { QrCodeSetupModel } from '@core/services/api.service';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { RegisterAuthenticatorAction } from '@ngxs-store/auth-store/auth.actions';
import { TwoFaDialogComponent } from '../two-fa-dialog/two-fa-dialog';

@Component({
  selector: 'app-qr-code-dialog',
  templateUrl: './qr-code-dialog.html',
})
export class QrCodeDialogComponent  {
    @Input() isLoading: boolean;
    @Input() isMobileMode: boolean;
    @Select(AuthState.getQrCodeSetupModel) qrCodeSetupModel$: Observable<QrCodeSetupModel>;

    form: FormGroup;
    qrCodeUrl: string;
    manualEntryKey: string;
    username: string;
    type: string;
    isConfired: boolean;

  constructor(private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any,
    private store: Store) {
        this.username = data.username;
        this.type = data.type;
        this.isConfired = data.hasAuthenticatorConfigured;
    }

    ngOnInit(): void {
        if (!this.isConfired) {
          this.registerAuthenticator();
        }
    }



    onCancelClick(): void {
        this.dialogRef.closeAll();
        const dialogRef = this.dialogRef.open(TwoFaDialogComponent, { data: {username: this.username, type: this.type}});
        dialogRef.afterClosed().subscribe(result => {});
    }

    registerAuthenticator() {
        this.store.dispatch(new RegisterAuthenticatorAction({username: this.username}));

        this.qrCodeSetupModel$.subscribe((qrCodeSetupModel: QrCodeSetupModel) => {
        if (qrCodeSetupModel) {
            this.qrCodeUrl = qrCodeSetupModel.qrCodeSetupImageUrl;
            this.manualEntryKey = qrCodeSetupModel.manualEntryKey;
        }
        });
    }

}
